import { useEffect } from 'react';

// Ref-counted scroll lock. Multiple modals can open at once (e.g. an alert
// inside a slide-over) — each call increments the count and only the last
// release removes the body class. The CSS in globals.css does the work:
// body.is-locked freezes both the document and the layout's <main> scroller
// so iOS can't chain pan gestures from a modal backdrop to the page behind.
let count = 0;

export function lockScroll() {
  count++;
  if (count === 1) document.body.classList.add('is-locked');
}

export function unlockScroll() {
  count = Math.max(0, count - 1);
  if (count === 0) document.body.classList.remove('is-locked');
}

export function useScrollLock(active: boolean) {
  useEffect(() => {
    if (!active) return;
    lockScroll();
    return unlockScroll;
  }, [active]);
}
